import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=0615bc40&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=ts"
export * from "./Recipes.vue?vue&type=script&lang=ts"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=0615bc40&prod&scoped=true&lang=css"
import style1 from "./Recipes.vue?vue&type=style&index=1&id=0615bc40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0615bc40",
  null
  
)

export default component.exports